const state = {
  globalFiltersDefault: [
    'ABS',
    'ADP',
    'ALBS',
    'BT',
    'DS',
    'DSK',
    'IJT',
    'IJTK',
    'OJT',
    'PBT',
    'PJT',
    'PROP',
    'SN',
    'WBHS'
  ],
  globalFilters: []
}

// getters
const getters = {
  globalFilters: state => state.globalFilters,
  globalFiltersDefault: state => state.globalFiltersDefault
}

const mutations = {
  setFilters (state, payload) {
    state.globalFilters.splice(0, state.globalFilters.length)
    payload.filters.forEach(item => {
      state.globalFilters.push(item)
    })
  }
}

// actions
const actions = {
  setFilters: ({ commit }, filters) => {
    commit({ type: 'setFilters', filters })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
